import React, { useContext, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';

import { trackPage } from './analytics.js'; // sau ./analytics dacă redenumești

import ForumInLucru from './footer/ForumInLucru.jsx';

import { Header } from './header/Header';
import { Home } from './firstpage/Home.jsx';
import { About } from './footer/About';
import CursuriPresentation from './footer/CursuriPresentation';
import JocuriPresentation from './footer/JocuriPresentation';

import { Registrer } from './content/Registrer';
import { Login } from './content/Login';
import { AuthProvider } from './AuthContext';
import { DarkModeProvider, useDarkMode } from './DarkModeContext';
import LoadingOverlay from './content/LoadingOverlay';
import Maintenance from './Maintenance';
import './styles/darkmode.css';
import FooterBlog from './content/blog/FooterBlog';
import VerifyCertificate from './diploma/VerifyCertificate.jsx';
import OnboardingIntro from './quizstart/OnboardingIntro.jsx';

import ContaPrimara from './content/cursuri/contaprimara/ContaPrimara.jsx';
import ContaPrimaraCourse from './content/cursuri/contaprimara/ContaPrimaraCourse.jsx';
import ContaPrimaraSyllabus from './content/cursuri/contaprimara/components/ContaPrimaraSyllabus.jsx';
import ContaAplicata from
  './content/cursuri/contabilitateaplicata/ContaAplicata.jsx';


import MenuFooter from './footer/MenuFooter';




import EmailConnect from './content/EmailConnect';
import ForgotPassword from './content/ForgotPassword';
import ResetPassword from './content/ResetPassword';

import RedirectAfterLogin from './RedirectAfterLogin';

import ConfirmationPage from './content/ConfirmationPage';
// ...existing code...

import FinancialCourse from './content/cursuri/contafinanciara/FinancialCourse';
import LoggedPremiumPlans from './PricingPlans/LoggedPremiumPlans.jsx';

















import { Footer } from './footer/Footer';
import './App.css';
import { LessonsContainer } from './content/lessons/LessonsContainer';




import Finaloffer from './header/offer/Finaloffer';

// Stilurile vechii pagini de plată rămân încărcate: au reguli globale (.d-flex.justify-content-between,
// .text-center, .section-title, antetul din Setări) pe care se sprijină pagini încă active.
import './header/offer/offer.css';
import './header/offer/stripepaymentform.css';
import PremiumPricing from './premium/PremiumPricing';
import PremiumCheckout from './premium/PremiumCheckout';
import PremiumSuccess from './premium/PremiumSuccess';


import LessonsLayout from './content/LessonsLayout';





import Viewplans from './header/offer/Viewplans';



import BazeleConta from './content/coursespublicpage/BazeleConta';
import ContaFinanciara from './content/coursespublicpage/ContaFinanciara';


import FunctionalPageLogin from './content/functionalpagelogin/FunctionalPageLogin.jsx';


import Blog from './content/blog/Blog.jsx';
import CheckCertification from './content/functionalpagelogin/InsideFooter/CheckCertification';
import CertificateInfo from './content/functionalpagelogin/InsideFooter/CertificateInfo';


import QuizStart from './quizstart/QuizStart';
import ScrollToTop from './ScrollToTop';
import Chaptercontainer from './content/cursuri/Chaptercontainer';

import Ajutor from './users/Ajutor';
//import ProtectedRoute from './ProtectedRoute';
import DiplomaPage from './diploma/DiplomaPage';
import Diplome from './users/Diplome';
import CoursesProgressPage from './users/CoursesProgressPage';
import Medals from './users/Medals';

import FAQ from './footer/FAQ';
import Termeni from './footer/Termeni';


import { Feedback } from './footer/Feedback';




import Politica from './footer/Politica';
import Politicacookies from './footer/Politicacookies';
import GDPR from './footer/GDPR';
import ANPC from './footer/ANPC';
//import { publicRoutes } from './content/publicRoutes';

import CookieConsent from './CookieConsent'; 
import { redirectToLogin } from './utils/authRedirect';

const AdminDashboard = React.lazy(() => import('./admin/AdminDashboard'));






// Adaugă URL-ul API-ului folosind variabila de mediu
const apiUrl = process.env.REACT_APP_API_URL;
const protectedRoutes = new Set([
  '/admin',
  '/functionalpagelogin',
    '/cursuri',
  '/chaptercontainer',
  '/chaptercontainercf',
  '/showlessons',
  '/showlessonscf',
  '/setari',
  '/settings',
 '/check-certification',
 
  '/diploma',
  '/diplome',
  '/courses-progress',
  '/medals',
  '/userpage'
]);

const isProtectedRoute = (pathname) => {
  const p = pathname.toLowerCase();

  return (
    protectedRoutes.has(p) ||
    p.startsWith('/premium')
  );
};


function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { user, loading: authLoading } = require('./AuthContext').useAuth();





useEffect(() => {
  trackPage(location.pathname + location.search);
}, [location]);

  useEffect(() => {
    if (!authLoading && !user && isProtectedRoute(location.pathname)) {
      redirectToLogin();
    }
  }, [authLoading, location.pathname, user]);



     // pornește overlay la fiecare schimbare de rută
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 100); // 0.6s pauză
    return () => clearTimeout(t);
  }, [location.pathname]);

  const lessonIsActive = location.pathname === '/chaptercontainer';
  const lessonCfIsActive = location.pathname === '/chaptercontainercf';
  const showLessonIsActive = location.pathname === '/showlessons';
  const showLessonCfIsActive = location.pathname === '/showlessonscf';

 const path = location.pathname.toLowerCase();

const showMenuFooter = (
  path === '/about' ||
  path === '/diploma' ||
  path === '/feedback' ||
  path === '/cursuri-prezentare' ||
  path === '/jocuri-prezentare' ||
  path === '/faq' ||
  path === '/termeni' ||
  path === '/politica' ||
  path === '/politicacookies' ||
  path === '/gdpr' ||
  path === '/anpc' ||
  path === '/ajutor'
);






const BlogIsActive = location.pathname.startsWith('/blog');
  
  const FinalofferActive = location.pathname === '/finaloffer';
  const ContaPrimaraIsActive = location.pathname === '/contabilitate-primara/lesson';

  const ContaAplicataIsActive =
  location.pathname === '/contabilitate-aplicata/lesson';

 const functionalpageloginActive =
  location.pathname === '/cursuri';

  const onboardingIntroActive = location.pathname === '/onboarding-intro';
 

 const CheckCertificationIsActive = location.pathname === '/check-certification';
  const PremiumActive = location.pathname.toLowerCase().startsWith('/premium');
  const redirectingActive = location.pathname === '/redirecting'; // 👈 ADĂUGAT
  const mentenanceActive = location.pathname === '/mentenance';


  
  const DiplomaIsActive = location.pathname === '/diploma';
  const DiplomeIsActive = location.pathname === '/diplome';
  const CoursesProgressActive = location.pathname === '/courses-progress';
  const SetariIsActive = location.pathname === '/setari';










  const hideHeader = (
    lessonIsActive ||
    lessonCfIsActive ||
    onboardingIntroActive ||
    functionalpageloginActive ||
    BlogIsActive ||
    CheckCertificationIsActive ||
    FinalofferActive ||
    PremiumActive ||
    showLessonIsActive ||
    showLessonCfIsActive ||
    SetariIsActive ||
    mentenanceActive ||
   
    DiplomeIsActive ||
    CoursesProgressActive ||
    redirectingActive ||
    ContaPrimaraIsActive ||
    ContaAplicataIsActive ||

    location.pathname === '/quiz-start' // ascunde header pe pagina quiz
  );

  const hideFooter = (
    location.pathname === '/quiz-start' ||
    lessonIsActive ||
    lessonCfIsActive ||
    showLessonIsActive ||
    showLessonCfIsActive ||  
 onboardingIntroActive ||
    functionalpageloginActive ||
ContaAplicataIsActive ||
    ContaPrimaraIsActive ||
    mentenanceActive ||
    location.pathname === '/setari' ||
    DiplomaIsActive ||
    FinalofferActive ||
    PremiumActive ||
    redirectingActive // 👈 ADĂUGAT
  );

  if (!authLoading && !user && isProtectedRoute(location.pathname)) {
    return null;
  }

  // Redirecționează userul autentificat de pe /home sau / către /functionalpagelogin
  if (!authLoading && user && (location.pathname === '/home' || location.pathname === '/')) {
    return <Navigate to="/cursuri" replace />;
  }

  return (
    <>
      {loading && location.pathname !== '/redirecting' && <LoadingOverlay />}
      <CookieConsent />
  
      {!hideHeader && (showMenuFooter ? <MenuFooter /> : <Header />)}

      <div className="d-flex flex-column v-100">
        <Routes>
           <Route path="/cursuri" element={<FunctionalPageLogin />} />

<Route
  path="/functionalpagelogin"
  element={<Navigate to="/cursuri" replace />}
/>


            <Route path="/userpage" element={<Navigate to="/functionalpagelogin" replace />} />
         <Route
  path="/onboarding-intro"
  element={<OnboardingIntro />}
/>
<Route
  path="/contabilitate-primara/lesson"
  element={<ContaPrimara />}
/>
<Route
  path="/curs_conta-primara"
  element={<ContaPrimaraCourse />}
/>
          <Route path="/quiz-start" element={<QuizStart />} />
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Navigate to="/" replace />} />
           <Route path="mentenance" element={<Maintenance />} />
          <Route path="/about" element={<About />} />
       
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/cursuri-prezentare" element={<CursuriPresentation />} />
          <Route path="/jocuri-prezentare" element={<JocuriPresentation />} />
          <Route
  path="/verify/:certificateCode"
  element={<VerifyCertificate />}
/>

<Route
  path="/contabilitate-aplicata/lesson"
  element={<ContaAplicata />}
/>

<Route
  path="/forum-in-lucru"
  element={<ForumInLucru />}
/>

<Route
  path="/premium/plans"
  element={<LoggedPremiumPlans />}
/>
          
          <Route path="/login" element={<Login />} />
          <Route path="/emailconnect" element={<EmailConnect />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirmationemail" element={<ConfirmationPage />} />
          <Route path="/registrer" element={<Registrer />} />
          <Route path="/lessonscontainer" element={<LessonsContainer />} />
          
          <Route path="/blog" element={<Blog />} />
          <Route path="/check-certification" element={<CheckCertification />} />
          <Route
  path="/certification"
  element={<CertificateInfo />}
/>
          <Route path="/chaptercontainer" element={<Chaptercontainer />} />
          <Route
  path="/showlessons-financial"
  element={<FinancialCourse />}
/>

<Route
  path="/contabilitate-primara/programa"
  element={<ContaPrimaraSyllabus />}
/>
        
          
          <Route path="/faq" element={<FAQ />} />
       
          <Route path="/termeni" element={<Termeni />} />
          <Route path="/politica" element={<Politica />} />
          <Route path="/politicacookies" element={<Politicacookies />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/anpc" element={<ANPC />} />
       
        
         
          <Route path="/finaloffer" element={<Finaloffer />} />
          <Route path="/viewplans" element={<Viewplans />} />

{/* Vechile pagini de plan / facturare duc acum la checkout-ul Stripe. */}
<Route path="/planlunar" element={<Navigate to="/premium/checkout?plan=premium_monthly" replace />} />
<Route path="/plan3luni" element={<Navigate to="/premium/checkout?plan=premium_quarterly" replace />} />

         
          <Route path="/facturare" element={<Navigate to="/premium/plans" replace />} />
         
          <Route path="/paymentpage" element={<Navigate to="/premium/plans" replace />} />
          <Route path="/premium" element={<PremiumPricing />} />
          <Route path="/premium/checkout" element={<PremiumCheckout />} />
          <Route path="/premium/succes" element={<PremiumSuccess />} />
          <Route path="/redirecting" element={<RedirectAfterLogin />} />
        
          
          <Route path="/bazeleconta" element={<BazeleConta />} />
          <Route path="/contafinanciara" element={<ContaFinanciara />} />
         
<Route
  path="/chapter-preview/:chapterId"
  element={<FunctionalPageLogin />}
/>
          {/* Setarile reale traiesc in shell-ul /functionalpagelogin; paginile standalone vechi redirectioneaza */}
          <Route path="/setari" element={<Navigate to="/functionalpagelogin" replace />} />
          <Route path="/planul-tau" element={<Navigate to="/functionalpagelogin" replace />} />
          <Route path="/resetareprogres" element={<Navigate to="/functionalpagelogin" replace />} />
          <Route path="/settings" element={<Navigate to="/functionalpagelogin?menu=setari" replace />} />
          <Route path="/admin" element={<React.Suspense fallback={null}><AdminDashboard /></React.Suspense>} />

          <Route path="/ajutor" element={<Ajutor />} />

        <Route element={<LessonsLayout />}>
          <Route path="/diploma" element={<DiplomaPage />} />
          <Route path="/diplome" element={<Diplome />} />
          <Route path="/courses-progress" element={<CoursesProgressPage />} />
          <Route path="/medals" element={<Medals />} />
        </Route>

          {/* Showlessons cu alt meniu */}
// ...existing code...

        <Route
  path="/showlessonscf"
  element={<FinancialCourse />}
/>
       
    



   


        </Routes>
      </div>

     {!hideFooter && (
  BlogIsActive
    ? <FooterBlog />
    : <Footer />
)}
    </>
  );
}



function App() {
  return (
    <AuthProvider>
      <DarkModeProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </DarkModeProvider>
    </AuthProvider>
  );
}




// Componenta principală




export default App;
